import { ReactNode } from 'react';

export enum Increment {
    Half = 'half',
    Point = 'point',
    Whole = 'whole',
}

export enum Size {
    XXXSmall = 'xxxs',
    XXSmall = 'xxs',
    XSmall = 'xs',
    Small = 'sm',
    Medium = 'md',
    Large = 'lg',
}

export type RatingColorByValueMap = { [key: number]: string };
export type RatingColorCallback = (rating?: number | null) => string;
export type RatingValueChangeCallback = (rating?: number) => void;

export interface RatingInputProps {
    className?: string;
    colorEmptyByValue: RatingColorByValueMap;
    colorFullByValue: RatingColorByValueMap;
    htmlName?: string;
    hoverValue?: number;
    iconEmpty?: string;
    iconFull?: string;
    increment?: Increment;
    isReadOnly?: boolean;
    onChange?: RatingValueChangeCallback;
    tabIndex?: number;
    selectedValue?: number | null;
    size?: Size;
    value: number;
}

export interface RatingInputsProps
    extends Omit<RatingInputProps, 'hoverValue' | 'value' | 'colorEmptyByValue' | 'colorFullByValue'> {
    potentialValues: number[];
    colorEmptyByValue?: RatingColorByValueMap;
    colorFullByValue?: RatingColorByValueMap;
}

export interface RatingValueProps {
    className?: string;
    colorFull?: string | RatingColorCallback;
    size?: Size;
    selectedValue?: number | null;
    valueMax?: number;
    numberFormat?: boolean;
}

export interface RatingScaleProps {
    className?: string;
    isDisplayScaleValue?: boolean;
    selectedValue?: number | null;
    sentimentNegativeImage?: string;
    sentimentNegativeLabel?: string | null;
    sentimentNeutralImage?: string;
    sentimentNeutralLabel?: string | null;
    sentimentPositiveImage?: string;
    sentimentPositiveLabel?: string | null;
    size?: Size;
}

export interface RatingScaleItemProps {
    className?: string;
    sentimentImage?: string;
    sentimentLabel?: string | null | ReactNode;
}

export interface RatingProps
    extends Omit<
        RatingInputsProps & RatingScaleProps & RatingValueProps,
        'colorFullByValue' | 'colorEmptyByValue' | 'potentialValues'
    > {
    colorEmpty?: string | RatingColorCallback;
    colorFull?: string | RatingColorCallback;
    isDisplayIcons?: boolean;
    isDisplayScale?: boolean;
    isDisplayStacked?: boolean;
    isDisplayValue?: boolean;
    onChange?: RatingValueChangeCallback;
    valueMax?: number;
    valueMin?: number;
    label?: string;
    noRatingText?: string;
    numberFormat?: boolean;
}

// defined here to avoid circular dependencies between util/Values and util/Props
export const DEFAULT_VALUE_MAX = 5;
export const DEFAULT_VALUE_MIN = 1;
